module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "selectRow"
  }, [_c('el-col', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入发行游戏名称"
    },
    model: {
      value: (_vm.issued_app_id),
      callback: function($$v) {
        _vm.issued_app_id = $$v
      },
      expression: "issued_app_id"
    }
  }, _vm._l((_vm.PlacementList), function(item, i) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.issued_app_id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.planConfig
    }
  }, [_vm._v("同步线上配置")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_name",
      "label": "广告位名称",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div', [_c('el-select', {
          staticClass: "xs24",
          attrs: {
            "filterable": "",
            "clearable": "",
            "placeholder": "请选择广告位名称"
          },
          model: {
            value: (_vm.plist[scope.$index].type),
            callback: function($$v) {
              _vm.$set(_vm.plist[scope.$index], "type", $$v)
            },
            expression: "plist[scope.$index].type"
          }
        }, _vm._l((_vm.config), function(v, i) {
          return _c('el-option', {
            key: v[0],
            attrs: {
              "label": v[0],
              "value": v[1]
            }
          })
        }), 1)], 1) : _c('div', [_vm._v(_vm._s(scope.row.type_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "广告位标识",
      "align": "left",
      "min-width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div', [_vm._v("\n      \t \t \t" + _vm._s(scope.row.type) + "\n      \t \t ")]) : _c('div', [_vm._v(_vm._s(scope.row.type))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "更新时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "广告位状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('div') : _c('div', [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.SaveSpace(scope.$index)
            }
          }
        }, [_vm._v("确认添加")]) : _vm._e(), _vm._v(" "), (!scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))]) : _vm._e(), _vm._v(" "), (!scope.row.isAdd) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '广告位日志',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  type: 'space'
                }
              })
            }
          }
        }, [_vm._v("更新日志")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ea5e45e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adControl/ADbanner.vue
// module id = 1091
// module chunks = 2